module.exports = __webpack_public_path__ + "static/media/book.d631cbae.jpg";